export enum CustomGridCellKind {
  Spinner = 'spinner-cell',
  Skeleton = 'skeleton',
}
